import { render } from "./deposit_bk.vue?vue&type=template&id=7f4d89c2&scoped=true"
import script from "./deposit_bk.vue?vue&type=script&lang=js"
export * from "./deposit_bk.vue?vue&type=script&lang=js"

import "./deposit_bk.vue?vue&type=style&index=0&id=7f4d89c2&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\project\\forex\\vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f4d89c2"]])

export default __exports__